"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _review = _interopRequireDefault(require("./review.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ParentWrapper = _styledComponents.default.div.withConfig({
  displayName: "Review__ParentWrapper",
  componentId: "sc-mu0oi8-0"
})(["display:flex;flex-direction:", ";position:relative;"], function (_ref) {
  var oneline = _ref.oneline;
  return oneline ? 'row' : 'column';
});

var ContainerTop = _styledComponents.default.div.withConfig({
  displayName: "Review__ContainerTop",
  componentId: "sc-mu0oi8-1"
})(["display:flex;position:relative;align-items:center;margin-bottom:", ";"], function (props) {
  return props.theme.space.micro;
});

var ScoreCard = _styledComponents.default.div.withConfig({
  displayName: "Review__ScoreCard",
  componentId: "sc-mu0oi8-2"
})(["display:flex;background:", ";background-color:", ";border-radius:", ";padding-left:", ";padding-right:", ";margin-right:", ";"], function (props) {
  return props.theme.colors[props.backgroundColor] || props.theme.colors.secondary;
}, function (_ref2) {
  var theme = _ref2.theme,
      move = _ref2.move;
  return move && theme.backgroundColor.darkGreen;
}, function (props) {
  return props.theme.borderRadius.small;
}, function (props) {
  return props.theme.space.micro;
}, function (props) {
  return props.theme.space.micro;
}, function (props) {
  return props.theme.space.micro;
});

var ReviewCountWrapper = _styledComponents.default.div.withConfig({
  displayName: "Review__ReviewCountWrapper",
  componentId: "sc-mu0oi8-3"
})(["margin-left:", ";"], function (_ref3) {
  var oneline = _ref3.oneline,
      theme = _ref3.theme;
  return oneline ? theme.space.tiny : '0';
});

var Review = function Review(props) {
  var theme = props.theme,
      data = props.data,
      accessible = props.accessible,
      customProperties = props.customProperties,
      backgroundColor = props.backgroundColor,
      messageColor = props.messageColor,
      reviewCountColor = props.reviewCountColor,
      fontSize = props.fontSize,
      lineHeight = props.lineHeight,
      scoreCardLeftColor = props.scoreCardLeftColor,
      scoreCardRightColor = props.scoreCardRightColor,
      oneline = props.oneline,
      textType = props.textType,
      reviewTranslation = props.reviewTranslation,
      move = props.move;

  var _ref4 = data || {},
      rating = _ref4.rating,
      message = _ref4.message,
      reviewCount = _ref4.reviewCount,
      maxRate = _ref4.maxRate;

  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var getMain = function getMain() {
    return data && /*#__PURE__*/_react.default.createElement(ParentWrapper, (0, _extends2.default)({
      theme: themeContext,
      tabIndex: tabIndex,
      oneline: oneline
    }, customProperties), /*#__PURE__*/_react.default.createElement(ContainerTop, null, rating && /*#__PURE__*/_react.default.createElement(ScoreCard, {
      backgroundColor: backgroundColor,
      move: move
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: scoreCardLeftColor,
      accessible: accessible,
      type: textType
    }, rating), /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: scoreCardRightColor,
      accessible: accessible,
      type: textType
    }, "".concat(_constant.DEFAULT_STYLES.SLASH).concat(maxRate || _constant.DEFAULT_MAX_RATING))), message && /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: messageColor,
      fontsize: fontSize,
      "line-height": lineHeight,
      accessible: accessible,
      type: textType
    }, message)), reviewCount && reviewCount > 0 && /*#__PURE__*/_react.default.createElement(ReviewCountWrapper, {
      oneline: oneline
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: reviewCountColor,
      fontsize: fontSize,
      "line-height": lineHeight,
      accessible: accessible,
      type: textType
    }, "".concat(_constant.DEFAULT_STYLES.PRE_REVIEW_COUNT).concat(reviewCount, " ").concat(reviewTranslation || _constant.DEFAULT_STYLES.REVIEW_COUNT).concat(_constant.DEFAULT_STYLES.POST_REVIEW_COUNT))));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Review.propTypes = _review.default.PropTypes;
Review.defaultProps = _review.default.DefaultProps;
var _default = Review;
exports.default = _default;